import StateObserver, { now, user } from 'src/StateObserver';
import PopupCheats, { Item } from '../cheats/PopupCheats';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { CheatData } from '../cheats/cheats.sequences';
import { closeAllPopups } from 'src/lib/popups/popupOpenClose';
import {
  getWeeklyLeaderboardFriendsRanking,
  getWeeklyLeaderboardGlobalRanking,
  getWeeklyLeaderboardRanking,
  runWeeklyleaderboardMatchMaking,
} from './weeklyLeaderboard.utils';
import { duration } from '@play-co/components';

const MATCH2_WEEKLY_LEADERBOARD = 'match2 Weekly Leaderboard';

const list = () => {
  const cheats: Record<string, CheatData[]> = {};

  cheats[MATCH2_WEEKLY_LEADERBOARD] = [
    {
      text: 'Reset Weekly Leaderboard',
      color: 'secondary',
      cheat: async () => {
        await StateObserver.invoke.cheat_resetWeeklyLeaderboard();
        await runWeeklyleaderboardMatchMaking()?.invalidate();
        await getWeeklyLeaderboardRanking()?.invalidate();
        await getWeeklyLeaderboardGlobalRanking().invalidate();
        await getWeeklyLeaderboardFriendsRanking().invalidate();
        closeAllPopups();
      },
    },
    {
      text: 'Score Weekly Leaderboard',
      color: 'secondary',
      cheat: async () => {
        await getWeeklyLeaderboardRanking()?.invalidate();
        await StateObserver.invoke.cheat_increaseWeeklyLeaderboardScore({
          score: 5,
        });
        await runWeeklyleaderboardMatchMaking()?.get();
      },
    },
    {
      text: 'Travel 1 Day Ahead',
      color: 'secondary',
      cheat: async () => {
        const currentOffset = await StateObserver.invoke.cheat_getClockOffset();
        const offset = currentOffset + duration({ days: 1 });
        await StateObserver.invoke.cheat_setClockOffset({ offset });
      },
    },
    {
      text: 'Reset Time',
      color: 'secondary',
      cheat: async () => {
        await StateObserver.invoke.cheat_setClockOffset({ offset: 0 });
      },
    },
  ];

  return cheats;
};

const ui = (args: {
  key: string;
  popup: PopupCheats;
  item: Item;
  title: LangBitmapFontTextView;
  setting: CheatData[];
  parent: Item | null;
}) => {
  if (args.key !== MATCH2_WEEKLY_LEADERBOARD) return;
  args.title.updateOpts({
    width: args.item.style.width - 40,
    height: 20,
    y: 8,
    align: 'center',
  });
  args.popup.createVerticalButtons(args.item, args.setting);
};

export const weeklyLeaderboardCheats = {
  list,
  ui,
};
